import React, { createElement } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import { Card } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';

// LOCAL VARIABLES
import { PLACEHOLDER } from '../../variables';

const ListCardBody = ({
  columns, //
  placeholder = PLACEHOLDER,
  resizeRow,
  row,
  rowNumber,
  rowWrapper: Wrapper = ({ children }) => children
}) => {
  return (
    <Wrapper record={row} resizeRow={resizeRow} rowNumber={rowNumber}>
      <Card.Body className="px-3 py-0">
        {columns.map((c, j) => {
          return (
            <div key={j} className="d-flex align-items-center py-3 border-top">
              <div className="text-gray-600 me-3">
                {c.label || (!!c.icon && (c.tooltip || <Sprite {...(isObject(c.icon) ? c.icon : { use: c.icon })} />))}
              </div>
              <div className={clsx('ms-auto text-end', c.className)}>
                {isFunction(c.component)
                  ? createElement(c.component, {
                      ...c,
                      value: row[c.key],
                      column: c,
                      row: { original: row },
                      resizeRow,
                      placeholder
                    })
                  : ![undefined, null, ''].includes(row[c.key])
                  ? row[c.key]
                  : placeholder}
              </div>
            </div>
          );
        })}
      </Card.Body>
    </Wrapper>
  );
};

// EXPORT
export default ListCardBody;
